/**
 * Content Viewer Modal for Profile
 */
export const initModal = () => {
    let modalEl = null;

    const buildModal = () => {
        const el = document.createElement('div');
        el.className = 'content-viewer-modal';
        el.innerHTML = `
            <div class="content-viewer-modal__backdrop"></div>
            <div class="content-viewer-modal__dialog" role="dialog" aria-modal="true">
                <div class="content-viewer-modal__header">
                    <span class="content-viewer-modal__folder"></span>
                    <button class="content-viewer-modal__close" aria-label="Close">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <div class="content-viewer-modal__body"></div>
                <div class="content-viewer-modal__footer">
                    <span class="content-viewer-modal__date"></span>
                    <a class="content-viewer-modal__source" href="#" target="_blank">
                        Source <i class="fa-solid fa-arrow-right-long"></i>
                    </a>
                </div>
            </div>`;
        document.body.appendChild(el);

        el.querySelector('.content-viewer-modal__backdrop').addEventListener('click', closeModal);
        el.querySelector('.content-viewer-modal__close').addEventListener('click', closeModal);

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modalEl && modalEl.classList.contains('is-open')) closeModal();
        });

        return el;
    };

    const openModal = ({ folder, body, date, sourceUrl, sourceLabel }) => {
        if (!modalEl) modalEl = buildModal();

        modalEl.querySelector('.content-viewer-modal__folder').textContent = folder || '';
        modalEl.querySelector('.content-viewer-modal__body').innerHTML = body || '';
        modalEl.querySelector('.content-viewer-modal__date').textContent = date || '';

        const src = modalEl.querySelector('.content-viewer-modal__source');
        if (sourceUrl) {
            src.href = sourceUrl;
            src.style.display = '';
            if (sourceLabel) src.querySelector('i').insertAdjacentText('beforebegin', sourceLabel + ' ');
        } else {
            src.style.display = 'none';
        }

        modalEl.classList.add('is-open');
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        if (!modalEl) return;
        modalEl.classList.remove('is-open');
        document.body.style.overflow = '';
    };

    // Open Modal globally for viewer clicks
    document.addEventListener('click', (e) => {
        const viewBtn = e.target.closest('.card-view-full-btn');
        if (!viewBtn) return;

        const card = viewBtn.closest('.saved-card, .note-item');
        if (!card) return;

        const isSaved = card.classList.contains('saved-card');

        const folder = isSaved
            ? card.querySelector('.current-folder')?.textContent?.trim()
            : card.querySelector('.note-item__collection')?.textContent?.trim();

        const bodyEl = isSaved
            ? card.querySelector('.fragment-text')
            : card.querySelector('.note-item__content');

        const dateEl = isSaved
            ? card.querySelector('.saved-card__date')
            : card.querySelector('.note-item__date');

        const linkEl = isSaved
            ? card.querySelector('.saved-card__link')
            : card.querySelector('.note-item__link a');

        openModal({
            folder: folder || 'General',
            body: bodyEl ? bodyEl.innerHTML : '',
            date: dateEl ? dateEl.textContent.trim() : '',
            sourceUrl: linkEl ? (linkEl.href || linkEl.querySelector('a')?.href) : null,
        });
    });

    return { openModal, closeModal };
};
